<template>
<div class="relative z-0">
	<div id="intro" class="intro relative">

		<div :class="[isMobile ? 'block' : 'hidden']" class="art" id="nonparallax">
			<div class="w-full mx-auto px-8 md:px-5 text-center text-gray-800" style="max-width: 500px; margin: auto">
					<div class="flex flex-col items-center justify-center">
						<a target="_blank" href="https://teamdigital.com"  @click="analytics.gaEvent('click', 'navigation', 'home_logo');"> <logo-td style="max-width: 100px; max-height: 40px" class="mt-5 mb-3"></logo-td> </a>
						<img class="mr-4" style="max-width: 200px" :src="secure_asset('assets/images/logo-wrap.png')" alt="Thats a wrap">
					</div>

					<p class="leading-tight">To wrap up our 25th year, the teamDigital family is proud to partner with Families Network of Western Connecticut to help make the holiday season merrier for families in need.</p>

					<p class="leading-tight"><span class="inline md:block">From toy shopping to creating custom gift wrap,</span> <strong>tap below</strong> to unwrap the story.</p>
				</div>

				<div style="transform: scale(.65);" class="tags flex justify-center items-start text-red-600 uppercase text-center font-bold">
					<div class="tag"><a @click="analytics.gaEvent('click', 'navigation', 'home_custom');" href="#wallpaper"><p class="mt-10 leading-tight">Custom<br /> Gift Wrap<br /> <i class="fas fa-angle-down"></i> </p></a></div>
					<div class="tag mt-20 -mx-10"><a @click="analytics.gaEvent('click', 'navigation', 'home_about');" href="#about"><p class="mt-10 leading-tight">About<br /> The Cause <br /> <i class="fas fa-angle-down"></i> </p></a></div>
					<div class="tag"><a @click="analytics.gaEvent('click', 'navigation', 'home_wrapping');" href="#event"><p class="mt-10 leading-tight">Wrapping<br /> Event <br /> <i class="fas fa-angle-down"></i></p></a></div>
				</div>
		</div>
		<div :class="[isMobile ? 'hidden' : 'block']" class="art" id="parallax">
			<div id="layer-0" class="parallax_layer parallax" data-speed="2">
				<div class="left parallax_layer"></div>
				<div class="right parallax_layer"></div>
				
		    </div><!--/ layer_0 /-->

		    <div id="layer-1" class="parallax_layer parallax" data-speed="5">
		    	<div class="top parallax_layer"></div>
				<div class="bottom parallax_layer"></div>
		    </div><!--/ layer-1 /-->

		    <div id="layer-2" class="parallax_layer parallax w-full h-full" data-speed="11">
				<div class="top parallax_layer"></div>
				<div class="bottom parallax_layer"></div>
			</div><!--/ layer-2 /-->

			 <div id="layer-3" class="parallax_layer parallax" data-speed="11">

			 	<div class="w-full md:w-2/4 max-w-2xl mt-10 mx-auto px-6 text-center text-gray-800">
					<div class="flex flex-col items-center justify-center">
						<a target="_blank" @click="analytics.gaEvent('click', 'navigation', 'home_logo');" href="https://teamdigital.com"> <logo-td style="max-width: 100px; max-height: 20px" class="mb-6"></logo-td> </a>
						<img class="mr-4" style="max-width: 200px" :src="secure_asset('assets/images/logo-wrap.png')" alt="Thats a wrap">
					</div>

					<p class="leading-tight">To wrap up our 25th year, the teamDigital family is proud to partner with Families Network of Western Connecticut to help make the holiday season merrier for families in&nbsp;need.</p>

					<p class="leading-tight"><span class="inline md:block">From toy shopping to creating custom gift wrap,</span> <span class="font-bold">click below</span> to unwrap the story.</p>
				</div>

				<div class="tags mt-8 flex justify-center items-start text-red-600 uppercase text-center font-bold">
					<div class="tag"><a @click="analytics.gaEvent('click', 'navigation', 'home_custom');" href="#wallpaper"><p class="mt-12 leading-tight">Custom<br /> Gift Wrap <br /> <i class="fas fa-angle-down fa-2x"></i></p></a></div>
					<div class="tag tag-2x mt-16 lg:-mx-20"><a @click="analytics.gaEvent('click', 'navigation', 'home_about');" href="#about"><p class="mt-10 leading-tight">About<br /> The Cause <br /> <i class="fas fa-angle-down fa-2x"></i></p></a></div>
					<div class="tag"><a @click="analytics.gaEvent('click', 'navigation', 'home_wrapping');" href="#event"><p class="mt-12 leading-tight">Wrapping<br /> Event <br /> <i class="fas fa-angle-down fa-2x"></i></p></a></div>
				</div>
			
				
			</div><!--/ layer-2 /-->
			
			<div id="layer-4" class="parallax_layer parallax pointer-events-none" data-speed="16">
				<div class="houses parallax_layer"></div>
				<div class="popup parallax_layer"></div>
				
		    </div><!-- / layer-3 /-->

	
		    <div id="layer-5" class="parallax_layer parallax pointer-events-none" data-speed="26">
						
		    </div> 

		    <div id="layer-6" class="parallax_layer parallax pointer-events-none" data-speed="36">
			   
			</div><!-- / layer-5 -->

			<div id="layer-7" class="parallax_layer parallax pointer-events-none" data-speed="50">
				
			</div> <!--/ layer-6 /-->

			<div id="layer-8" class="parallax_layer pointer-events-none" data-speed="120">
				
			</div> <!--/ layer-6 /-->

			<div class="parallax_cover">
				
			</div>

		</div> <!-- / parallax /-->

	</div> <!-- /#intro -->

	<div id="main-content" class="relative -mt-1">
		<div id="about" class="section bg-scene bg-blue-900 pt-5 pb-20 md:py-10">
			<div class="w-full px-3 md:w-3/4 mx-auto pt-6 ">
				
			
			<h1 class="md:mt-0 text-3xl font-bold text-white text-center uppercase leading-tight" role="text"><span class="m-0 normal-case block text-4xl text-orange-600 font-display tracking-widest">Proudly supporting</span>Families Network of <br /> Western Connecticut</h1>

				<div class="flex flex-col lg:flex-row mt-3 md:mt-10">
					<div class="w-full lg:w-2/5 md:px-5 text-center md:text-left">
						<p>The mission of Families Network of Western Connecticut (FNWC) – an independent, not-for-profit organization – is to strengthen families through parent education, helping prevent child abuse and neglect. Since 2003, FNWC has made a positive and lasting difference for thousands of families across the Greater Danbury, CT&nbsp;area.</p>

						<p>During the holiday season, FNWC also helps parents provide gifts for their children. teamDigital is honored to support this initiative by donating and wrapping gifts for such an important&nbsp;cause.</p>

						<a target="_blank" class="uppercase text-orange-600 hover:text-orange-700 font-bold lg:whitespace-no-wrap" href="http://fnwc.org/"><p>Visit their site and <span class="block">show your&nbsp;support&nbsp;<i class="fas fa-angle-right"></i></span></p></a>
					</div>
					<div class="w-full lg:w-3/5 max-w-2xl mx-auto w-full mt-6 md:mt-0">
						<div class="w-full">
						<video controls allowFullScreen ref="videoElement" @click="playVideo" class="w-full border-2 border-blue-500" :src="secure_asset('assets/images/fnwc.mp4')" :poster="secure_asset('assets/images/fnwc-preview.png')">
						</video>
						<div class="text-center text-white bg-blue-500 p-3 text-lg lg:text-2xl"><p class="m-0 leading-tight">Watch how Families Network of Western Connecticut is&nbsp;making a difference. </p></div>
					</div>
						
					</div>
				</div>
			</div>
		</div>

		<div id="wallpaper" class="section overflow-hidden">
			<div v-if="!activeWallpaper" class="wrapper-overlay z-10" @click.prevent="showWallpaper()">
				<div id="gifttag" class="gifttag relative">
					<div class="absolute left-0 max-w-sm mx-auto pt-32 p-8 right-0 text-gray-800 text-center">

						<p class="leading-none m-0 text-center font-display text-red-700 text-3xl">Adding A Personal Touch</p>
						<p class="m-0 text-center uppercase text-red-700 text-2xl font-bold">to our wrapping paper</p>

						<p class="leading-snug">To make each gift we delivered a little more holly jolly, our team of Creative elves worked up custom wrapping paper designs that’re more fun than eight prancing reindeer. <br />Well, almost.</p>

						<p class="leading-snug">From snowy animals<br /> to classic cartoons,<br /><span class="text-red-600 font-bold">click around to<br /> discover each one.</span></p>

					</div>
				</div>
			</div>
			<accordian :style="'background-image:url('+asset_url+'/assets/images/'+wallpaper.img+')'" :author="wallpaper.author" :title="wallpaper.title" v-for="(wallpaper, index) in wallpapers" :number="index" :key="index"></accordian>
		</div>

		<div id="event" class="section w-full px-3 md:w-3/4 mx-auto py-2 md:py-10 text-gray-800 mt-1">
			<p class="font-display leading-none m-0 md:text-4xl md:tracking-widest text-3xl text-center text-orange-600 tracking-wide">Wrapping Up Holiday Cheer</p>
			<p class="m-0 text-center uppercase text-blue-800 text-3xl font-bold">for Families in Need</p>


			<div class="max-w-2xl mx-auto lg:px-6 mb-6">
				<p class="text-center text-gray-800">With input from FNWC, our team of elves bought gifts for 29 children. From shopping for those perfect presents, to holding a special gift wrap event, to loading our sleigh for delivery to FNWC headquarters, check out how we put a bow on this holiday project.</p>
			</div>

			<div id="gallery" class="gallery">
				
				<figure v-for="(block, index) in blocks" :key="index" :class="'gallery__item gallery__item--'+(index+1)">
					<video v-show="blocks[index].media == 'video'" class="gallery__img" autoplay loop muted playsinline>
						<source :src="secure_asset('assets/images/gallery/'+ blocks[index].file)" type="video/mp4">
					</video>

					<img v-show="blocks[index].media == 'img'" class="gallery__img" :src="secure_asset('assets/images/gallery/'+blocks[index].file)" alt="">
				</figure>
			</div>

		</div><!-- /.section: END -->

		<div class="section bg-backdrop">
			<div class="w-full px-3 md:w-3/4 mx-auto py-10">
					<logo-25 class="my-5 mx-auto" style="max-width: 120px; max-height: 120px"></logo-25>
					<img :src="secure_asset('assets/images/greetings.png')" alt="" class="mx-auto" style="width: 90%; max-width: 550px; text-align: center">
					<h1 class="text-center -mt-2"><span class="block font-bold text-blue-700 text-2xl">from teamDigital</span></h1>

				<div class="w-full md:w-2/4 mx-auto px-10 md:px-0 text-gray-700" style="max-width: 500px;">
					<p class="text-center">From all of us at tD, we wish you and yours the jolliest of holiday seasons and a very happy new year!</p>

					<p class="text-center">As we celebrate 25 years, we look forward to what’s next for our industry and our clients.</p>
				</div>
			</div>

			<div class="inline-block flex flex-col items-center justify-center text-gray-500 text-gray-500 absolute bottom-0 left-0 right-0 mb-1">
				<a @click="analytics.gaEvent('click', 'navigation', 'home_td_bottomlogo');" target="_blank" href="https://teamdigital.com"> <logo-td style="max-width: 150px; max-height: 40px" class="mb-2"></logo-td> </a>
				<div>
					<a @click="analytics.gaEvent('click', 'navigation', 'home_td_linkedin');" target="_blank" href="https://www.linkedin.com/company/teamdigital-project-support-team"><i class="fab fa-linkedin fa-2x m-1"></i></a>
					<a @click="analytics.gaEvent('click', 'navigation', 'home_td_instagram');" target="_blank" href="https://www.instagram.com/teamdigital"><i class="fab fa-instagram fa-2x m-1"></i></a>
					<a @click="analytics.gaEvent('click', 'navigation', 'home_td_facebook');" target="_blank" href="https://www.facebook.com/teamdigital"><i class="fab fa-facebook-square fa-2x m-1"></i></a>
					<a  @click="analytics.gaEvent('click', 'navigation', 'home_td_twitter');"  target="_blank" href="https://twitter.com/teamdigital"><i class="fab fa-twitter-square fa-2x m-1"></i></a>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    export default {
        name: 'home',

        computed: {
            ...mapState('app', [
                'analytics',
                'promotion'
            ]),

        },

        data() {
        	return {
        		isMobile: null,
        		blocksToShow: 14,
        		totalBlocks: 0,
        		asset_url: 'https://s3.amazonaws.com/td.other/teamDigital/2019.holiday',
        		vid_playing: false,
        		activeWallpaper: false,
        		wallpapers: [
        		{
        				img: 'wallpaper-woodlands@2x.jpg',
        				author: 'Nicole Griswold',
        				title: 'Woodland Christmas',
        			},
        			{
        				img: 'wallpaper-words@2x.jpg',
        				author: 'Mike Clemens',
        				title: 'Punny Christmas',
        			},
        			{
        				img: 'wallpaper-iconic@2x.jpg',
        				author: 'Mike Corrigan',
        				title: 'Holiday Movies',
        			},
        			{
        				img: 'wallpaper-hipster@2x.jpg',
        				author: 'Evan Valente',
        				title: 'Hipster Holiday',
        			},
        			{
        				img: 'wallpaper-cats@2x.jpg',
        				author: 'Cat Bey-Wagner',
        				title: 'Meowy Christmas',
        			}
        		],

        		blocks: [
			        {
			          title: '',
			          media: 'video',
			          file: 'IMG_6062.mp4'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'IMG_2400.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'IMG_6009.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'DSCF9909.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'wrapping-paper.gif'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'DSCF9894.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'IMG_1650.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'DSCF9833.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'video',
			          file: 'boomerang2.mp4'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'IMG_1640.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'DSCF9891.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'IMG_6028.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'img010.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'IMG_2401.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'DSCF9905.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'IMG_7661.jpg'
			        },
			         {
			          title: 'the last block',
			          media: 'img',
			          file: 'IMG_3059.jpg'
			        },
			        
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'DSCF9918.jpg'
			        },
			         {
			          title: 'the last block',
			          media: 'img',
			          file: 'img11.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'IMG_1651.jpg'
			        },
			         {
			          title: 'the last block',
			          media: 'video',
			          file: 'boomerang3.mp4'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'DSCF9950.jpg'
			        },
			         {
			          title: 'the last block',
			          media: 'img',
			          file: 'DSCF9906.jpg'
			        },
			          {
			          title: 'the last block',
			          media: 'video',
			          file: 'boomerang4.mp4'
			        },
			       
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'DSCF9904.jpg'
			        },
			          {
			          title: 'the last block',
			          media: 'img',
			          file: 'DSCF9886.JPG'
			        },
			          {
			          title: 'the last block',
			          media: 'img',
			          file: 'IMG_6031.jpg'
			        },
			        {
			          title: 'the last block',
			          media: 'img',
			          file: 'tree.gif'
			        },
			       
			
			      ]
        	}
        },

        mounted() {

        	

            // store the analytics campaign 
            this.analytics.setCampaign(this.$route.query);

            // check if mobile, make it nonparallax
            if ("ontouchstart" in document.documentElement) {
				this.isMobile = true;
			} else {
				this.isMobile = false;
			}

			var browser = window.navigator.userAgent;
       		var msie = browser.indexOf("MSIE ");
       
       		// we need to test if the browser is IE, if so don't add any of the parallax
         	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
          		this.isMobile = true;
	        } 

            window.addEventListener('scroll', this.parallaxScroll);
            window.addEventListener('scroll', this.highlightNavigation);
            window.addEventListener('scroll', this.checkWallpaper);
            window.addEventListener('scroll', this.checkVideoPlay);

            // Select all links with hashes
			$('a[href*="#"]')
			  // Remove links that don't actually link to anything
			  .not('[href="#"]')
			  .not('[href="#0"]')
			  .click(function(event) {
			    // On-page links
			    if (
			      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
			      && 
			      location.hostname == this.hostname
			    ) {
			      // Figure out element to scroll to
			      var target = $(this.hash);
			      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			      // Does a scroll target exist?
			      if (target.length) {
			        // Only prevent default if animation is actually gonna happen
			        event.preventDefault();
			        $('html, body').animate({
			          scrollTop: target.offset().top
			        }, 1000, function() {
			          // Callback after animation
			          // Must change focus!
			          var $target = $(target);
			          $target.focus();
			          if ($target.is(":focus")) { // Checking if the target was focused
			            return false;
			          } else {
			            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
			            $target.focus(); // Set focus again
			          };
			        });
			      }
			    }
			  });

			//lets create the magic
			var tween = TweenMax.fromTo(".tag", 1,
							{rotation: 1},
							{rotation: -1, repeat: -1,repeatDelay: 0, yoyo: true, ease: Circ.easeInOut}
						);

			var riseForeHouses = TweenMax.fromTo('#layer-4 > .houses', .5, {top: 250}, {delay: .25, top: 0, ease: Back.easeOut.config(1.7)})
			var riseBackHouses = TweenMax.fromTo('#layer-2 > .top', .5, {top: 200}, {top: 0, ease: Back.easeOut.config(1.7)})
			var riseFarHouses = TweenMax.fromTo('#layer-1 > .top', .5, {top: 150}, {top: 0, ease: Back.easeOut.config(1.7)})
			var dropTags = TweenMax.fromTo('.tag', .5, {top: -100, opacity: 0}, {opacity: 1, top: 0, ease: Back.easeOut.config(2)})

			var initFirstScene = new TimelineLite()
				initFirstScene.add(riseForeHouses)
				initFirstScene.add(riseBackHouses)
				initFirstScene.add(riseFarHouses)
				initFirstScene.add(dropTags)
	
			var partLeft = TweenMax.fromTo('#layer-0 > .left', 1, {backgroundPosition: 'center bottom'}, {backgroundPosition: '-100px bottom', ease: Power0.easeNone,})
			var partRight = TweenMax.fromTo('#layer-0 > .right', 1, {backgroundPosition: 'center bottom'}, {backgroundPosition: '100px bottom',  ease: Power0.easeNone,})

			var partTheSkies = new TimelineLite()
				partTheSkies.add(partLeft)
				partTheSkies.add(partRight)
				partTheSkies.pause()

			var tagSwayTL = new TimelineLite()
				tagSwayTL.fromTo('.gifttag', .5, 
								{top: -200},
								{top: 0, repeat: 0, ease: Elastic.easeOut.config(1, 0.2), }
						)
				tagSwayTL.fromTo('.gifttag', .5, {className: 'gifttag'}, {className: 'gifttag embellish'})
				tagSwayTL.pause();

			var extendPin = TweenMax.fromTo('.logo-fnwc > .pill-fnwc', .5, {className: 'pill-fnwc rounded-full uppercase text-white'}, {className: 'pill-fnwc rounded-full uppercase text-white active', ease: Circ.easeInOut})
			var shiftPin = TweenMax.fromTo('.logo-fnwc', .5, {className: 'bottom-0 fixed logo-fnwc p-4 right-0 z-30'}, {className: 'bottom-0 fixed logo-fnwc p-4 right-0 z-30 mb-20 md:mb-0', ease: Circ.easeInOut})

			

			var controller = new ScrollMagic.Controller();

				//// build the scenes scene
				var scene = new ScrollMagic.Scene({triggerElement: '#intro'})
				.setTween(tween)
				//.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
				.addTo(controller);

				var initScene = new ScrollMagic.Scene({triggerElement: '#intro'})
				.setTween(initFirstScene)
				//.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
				.addTo(controller);

				var partSkies = new ScrollMagic.Scene({triggerElement: '#about', duration: 200, triggerHook: .8})
				.setTween(partTheSkies)
				.addTo(controller)

				var gifttag = new ScrollMagic.Scene({triggerElement: "#wallpaper", triggerHook: .5})
				.setTween(tagSwayTL)
			//	.addIndicators({name: "2 (trigger)"})
				.addTo(controller)

				var expandfnwc = new ScrollMagic.Scene({triggerElement: ".bg-backdrop" })
				.setTween(extendPin)
				.addTo(controller)

				var shiftPin = new ScrollMagic.Scene({triggerElement: ".bg-backdrop" })
				.setTween(shiftPin)
				.addTo(controller)

        },

        methods: {

        	...mapActions('app', [
        		'setActiveWrappingPaper'
        	]),

        	parallaxScroll() {
        		var windowScroll = $(window).scrollTop();
		
				$('.parallax_layer.parallax').each(function(){
					var $layer = $(this);
					var yPos = -(windowScroll * $layer.data('speed') / 100);
					$layer.css({
						"transform" : "translate3d(0px, " + yPos + "px, 0px)"
					});

				});

        	},

        	showWallpaper() {
        		this.activeWallpaper = !this.activeWallpaper;
        	},

        	checkWallpaper() {
        		var wrapperBox = document.getElementById('wallpaper');
        		var boundingWrapper = wrapperBox.getBoundingClientRect();

        		var windowScroll1 = $(window).scrollTop();

        		var wrapperBoxHeight = wrapperBox.offsetTop;



        		//if the user scrolls past the wallpaper
			    if (boundingWrapper.bottom < -1 || windowScroll1 < wrapperBoxHeight) {
			    	this.activeWallpaper = false;

			    	this.setActiveWrappingPaper(null);
			    };

        	},

        	checkVideoPlay() {
        		var video = document.getElementsByTagName('video')[0];
        		var videoBox = document.getElementById('about');
				var boundingVideo = video.getBoundingClientRect();


				if (boundingVideo.top < -200 || boundingVideo.top > 700) {
					video.pause()
				}
        	},


        	highlightNavigation() {
        		// cache the navigation links 
				var $navigationLinks = $('#navigation > ul > li > a');
				// cache (in reversed order) the sections
				var $sections = $($(".section").get().reverse());

				// map each section id to their corresponding navigation link
				var sectionIdTonavigationLink = {};
				$sections.each(function() {
				    var id = $(this).attr('id');
				    sectionIdTonavigationLink[id] = $('#navigation > ul > li > a[href=\\#' + id + ']');
				});

			    // get the current vertical position of the scroll bar
			    var scrollPosition = $(window).scrollTop();

			    // iterate the sections
			    $sections.each(function() {
			        var currentSection = $(this);
			        // get the position of the section
			        var sectionTop = currentSection.offset().top;

			        // if the user has scrolled over the top of the section  
			        if (scrollPosition >= sectionTop) {
			            // get the section id
			            var id = currentSection.attr('id');
			            // get the corresponding navigation link
			            var $navigationLink = sectionIdTonavigationLink[id];
			            // if the link is not active
			            if (!$navigationLink.hasClass('active')) {
			                // remove .active class from all the links
			                $navigationLinks.removeClass('active');
			                // add .active class to the current link
			                $navigationLink.addClass('active');
			            }
			            // we have found our section, so we return false to exit the each loop
			            return false;
			        } 

	

			        if ( window.scrollY == 0) {
			        	
			        	$navigationLinks.removeClass('active');
			        	$('#navigation > ul > li > a').eq(0).addClass('active');
			        }
			    });
			},
			playVideo() {
	            var vid = this.$refs['videoElement'];
	            var parent = this;

	           
	            this.vid_playing = !this.vid_playing;
	     
	            parent.analytics.gaEvent('click', 'navigation', 'home_video_play');
	            vid.addEventListener("play", function() {
	            
	                
	            });

	            vid.addEventListener("ended", function() {
	              
	                vid.currentTime = 0;
	                this.vid_playing = !this.vid_playing;
	                parent.analytics.gaEvent('click', 'navigation', 'home_video_complete');
	            });
	        },

	        loadMore() {
		    	this.totalSize = this.loadMoreSize + this.blocks.length;
		   	},

		   	expand() {
		   		var gallery = document.getElementById('gallery');
		   		

		   		if (gallery.classList.contains('expand')) {
		   			gallery.classList.add('expand-again')
		   		} else {
		   			gallery.classList.add('expand');
		   		}
		   	}








        }
    }
</script>
